import React from 'react';
import { FiCopy, FiDownload, FiSave } from 'react-icons/fi';
import Modal from './Modal';
import logger from '@/utils/logger';

function PromptModal({ isOpen, onClose, promptText, onSave }) {
  const handleCopy = () => {
    navigator.clipboard.writeText(promptText);
    logger.success('Prompt copied to clipboard.');
  };

  const handleDownload = () => {
    const blob = new Blob([promptText], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'promptly-generated-prompt.txt';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Generated Prompt">
      <div className="space-y-4">
        <textarea
          readOnly
          value={promptText}
          className="w-full h-64 p-2 font-mono text-xs bg-gray-100 border border-gray-300 rounded-md"
        />
        <div className="flex flex-wrap gap-2">
          <button onClick={handleCopy} className="inline-flex items-center px-3 py-1.5 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
            <FiCopy className="mr-2" /> Copy Prompt
          </button>
          <button onClick={handleDownload} className="inline-flex items-center px-3 py-1.5 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
            <FiDownload className="mr-2" /> Download .txt
          </button>
          {onSave && (
            <button onClick={onSave} className="inline-flex items-center px-3 py-1.5 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700">
              <FiSave className="mr-2" /> Save Prompt to Project
            </button>
          )}
        </div>
      </div>
    </Modal>
  );
}

export default PromptModal;